import Script from 'next/script';
import React from 'react';

const AffiliateInitScript = () => {
  return (
    <>
      <Script
        id="affiliate-init"
        dangerouslySetInnerHTML={{
          __html: `
              (function(w, d, s, p, t) { w.gr = w.gr || function() { w.gr.q = w.gr.q || []; w.gr.q.push(arguments); }; p = d.getElementsByTagName(s)[0]; t = d.createElement(s); t.async = true; t.src = "https://app.getreditus.com/gr.js?_ce=90"; p.parentNode.insertBefore(t, p); })(window, document, "script"); gr("track", "pageview");
            `,
        }}
      />
      {/* <Script
        id="fpr-affiliate-init"
        dangerouslySetInnerHTML={{
          __html: `
              (function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);
              fpr("init", {cid:"${FIRSTPROMOTER_SECRET_CID}"}); 
              fpr("click");
            `,
        }}
      /> */}
      {/* <Script
        id="affiliate-cdn"
        src="https://cdn.firstpromoter.com/fpr.js"
        async
      /> */}
    </>
  );
};

export default AffiliateInitScript;
